/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  FetchIssuerMetadataRequestBody,
  FetchIssuerMetadataRequestBody$Outbound,
  FetchIssuerMetadataRequestBody$outboundSchema,
} from "../components/fetchissuermetadatarequestbody.js";

export type FetchRemoteSessionIssuerMetadataSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type FetchRemoteSessionIssuerMetadataSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type FetchRemoteSessionIssuerMetadataSecurity = {
  option1?: FetchRemoteSessionIssuerMetadataSecurityOption1 | undefined;
  option2?: FetchRemoteSessionIssuerMetadataSecurityOption2 | undefined;
};

export type FetchRemoteSessionIssuerMetadataRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  fetchIssuerMetadataRequestBody: FetchIssuerMetadataRequestBody;
};

/** @internal */
export type FetchRemoteSessionIssuerMetadataSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const FetchRemoteSessionIssuerMetadataSecurityOption1$outboundSchema:
  z.ZodMiniType<
    FetchRemoteSessionIssuerMetadataSecurityOption1$Outbound,
    FetchRemoteSessionIssuerMetadataSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function fetchRemoteSessionIssuerMetadataSecurityOption1ToJSON(
  fetchRemoteSessionIssuerMetadataSecurityOption1:
    FetchRemoteSessionIssuerMetadataSecurityOption1,
): string {
  return JSON.stringify(
    FetchRemoteSessionIssuerMetadataSecurityOption1$outboundSchema.parse(
      fetchRemoteSessionIssuerMetadataSecurityOption1,
    ),
  );
}

/** @internal */
export type FetchRemoteSessionIssuerMetadataSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const FetchRemoteSessionIssuerMetadataSecurityOption2$outboundSchema:
  z.ZodMiniType<
    FetchRemoteSessionIssuerMetadataSecurityOption2$Outbound,
    FetchRemoteSessionIssuerMetadataSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function fetchRemoteSessionIssuerMetadataSecurityOption2ToJSON(
  fetchRemoteSessionIssuerMetadataSecurityOption2:
    FetchRemoteSessionIssuerMetadataSecurityOption2,
): string {
  return JSON.stringify(
    FetchRemoteSessionIssuerMetadataSecurityOption2$outboundSchema.parse(
      fetchRemoteSessionIssuerMetadataSecurityOption2,
    ),
  );
}

/** @internal */
export type FetchRemoteSessionIssuerMetadataSecurity$Outbound = {
  Option1?:
    | FetchRemoteSessionIssuerMetadataSecurityOption1$Outbound
    | undefined;
  Option2?:
    | FetchRemoteSessionIssuerMetadataSecurityOption2$Outbound
    | undefined;
};

/** @internal */
export const FetchRemoteSessionIssuerMetadataSecurity$outboundSchema:
  z.ZodMiniType<
    FetchRemoteSessionIssuerMetadataSecurity$Outbound,
    FetchRemoteSessionIssuerMetadataSecurity
  > = z.pipe(
    z.object({
      option1: z.optional(z.lazy(() =>
        FetchRemoteSessionIssuerMetadataSecurityOption1$outboundSchema
      )),
      option2: z.optional(z.lazy(() =>
        FetchRemoteSessionIssuerMetadataSecurityOption2$outboundSchema
      )),
    }),
    z.transform((v) => {
      return remap$(v, {
        option1: "Option1",
        option2: "Option2",
      });
    }),
  );

export function fetchRemoteSessionIssuerMetadataSecurityToJSON(
  fetchRemoteSessionIssuerMetadataSecurity:
    FetchRemoteSessionIssuerMetadataSecurity,
): string {
  return JSON.stringify(
    FetchRemoteSessionIssuerMetadataSecurity$outboundSchema.parse(
      fetchRemoteSessionIssuerMetadataSecurity,
    ),
  );
}

/** @internal */
export type FetchRemoteSessionIssuerMetadataRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  FetchIssuerMetadataRequestBody: FetchIssuerMetadataRequestBody$Outbound;
};

/** @internal */
export const FetchRemoteSessionIssuerMetadataRequest$outboundSchema:
  z.ZodMiniType<
    FetchRemoteSessionIssuerMetadataRequest$Outbound,
    FetchRemoteSessionIssuerMetadataRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
      gramProject: z.optional(z.string()),
      fetchIssuerMetadataRequestBody:
        FetchIssuerMetadataRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
        gramProject: "Gram-Project",
        fetchIssuerMetadataRequestBody: "FetchIssuerMetadataRequestBody",
      });
    }),
  );

export function fetchRemoteSessionIssuerMetadataRequestToJSON(
  fetchRemoteSessionIssuerMetadataRequest:
    FetchRemoteSessionIssuerMetadataRequest,
): string {
  return JSON.stringify(
    FetchRemoteSessionIssuerMetadataRequest$outboundSchema.parse(
      fetchRemoteSessionIssuerMetadataRequest,
    ),
  );
}
